const getters = {
  asyncRoutes: state => state.permission.asyncRoutes,
  userInfo: state => state.user.userInfo,
  permissions: state => state.user.permissions,
  orgData: state => state.user.orgData,
}

export default getters;